import { node } from "~/util/dom";
import { ACTIVITY_MOODS } from "~/activities/constants";
import { getEmo1Neg, getEmo1Pos, getEmoNeu, IEmojiOutput } from "~/ui/review/emojis-list";
import { _ } from "~/i18n";
import { TActivityMoodType } from "~/interfaces";

export type TTripsEmojiMood = TActivityMoodType | "none";

interface IITem {
	data: IEmojiOutput;
	type: TTripsEmojiMood;
}

interface ITripsEmoji {
	selected?: TTripsEmojiMood;
	onChange?: (type: TTripsEmojiMood) => void;
}

const SIZE = 40;

// vytvorit poznamku
export function createMyMapsTripsEmoji({
	selected = "none",
	onChange = () => {},
}: ITripsEmoji) {
	const container = node("div", { className: "mymaps-tripsEmoji" });
	const pText = node("div", { className: "mymaps-tripsEmoji__text", textContent: _("mymap.activity.edit.mood") });
	const moods = node("div", { className: "mymaps-tripsEmoji__moods" });
	const items: Array<IITem> = [];
	let activeType = selected;

	function selectMood(type: TTripsEmojiMood) {
		for (const item of items) {
			item.data.setActive(item.type === type && type !== activeType);
		}

		activeType = type;
		onChange(type);
	}

	for (const mood of ACTIVITY_MOODS) {
		const button = node("button", { type: "button", className: "mymaps-tripsEmoji__btn" });
		let data: IEmojiOutput = null;

		switch (mood.type) {
			case "smile":
				data = getEmo1Pos({
					active: true,
					size: SIZE,
				});
				break;

			case "bored":
				data = getEmoNeu({
					active: true,
					size: SIZE,
				});
				break;

			case "frown":
				data = getEmo1Neg({
					active: true,
					size: SIZE,
				});
				break;

			default:
		}

		data.setActive(mood.type === selected);
		button.append(data.container);
		button.addEventListener("click", () => {
			selectMood(mood.type);
		});
		items.push({
			data,
			type: mood.type,
		});
		moods.append(button);
	}

	container.append(pText, moods);

	return container;
}
